// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".circle-quantity[data-v-32939aca]{width:28px;height:28px;border-radius:20;display:flex;flex-direction:row;justify-content:center;align-items:center}", ""]);
// Exports
module.exports = exports;
